import React, { useState, useEffect } from 'react';
import useApiGet from '../hooks/getData';
import { useSelector } from 'react-redux';
import NoData from '../../assets/NoData.png';

function WeeklyReset() {
  const { getData } = useApiGet();
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);

  const [preview, setPreview] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchPreview = async () => {
    setLoading(true);
    try {
      const res = await getData('/rooms/coin-reset/preview');
      setPreview(res?.data?.hosts || []);
      setGrandTotal(res?.data?.grand_total || 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchHistory = async () => {
    try {
      const res = await getData('/rooms/coin-reset/history');
      setHistory(res?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchPreview();
    fetchHistory();
  }, []);

  // Current week ka start = last reset ki date, ya agar koi reset nahi hua to "beginning"
  const lastResetDate = history.length > 0 ? new Date(history[0].reset_at.replace(' ', 'T')) : null;

  // Next Monday 00:00 nikalo (jab agla automatic reset hoga)
  const getNextMonday = () => {
    const now = new Date();
    const day = now.getDay(); // 0=Sunday, 1=Monday...
    const daysUntilMonday = day === 1 ? 7 : (8 - day) % 7 || 7;
    const next = new Date(now);
    next.setDate(now.getDate() + daysUntilMonday);
    next.setHours(0, 0, 0, 0);
    return next;
  };
  const nextReset = getNextMonday();

  const formatDate = (d) => d.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });

  return (
    <div className={`dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
      <div className="px-4 pb-10 pt-6 xl:px-6">

        <h2 className="text-[#000000] font-semibold font-poppins text-xl pb-2 dark:text-darkText">
          Weekly Coin Reset
        </h2>
        <p className="text-sm font-poppins text-[#777777] pb-5">
          Coins are automatically transferred to hosts and reset every Monday at 12:00 AM — no manual action needed.
        </p>

        {/* Status Cards */}
        <div className="grid gap-4 pb-6 md:grid-cols-3">
          <div className="border border-opacity-gradient dark:border-[#1F1F1F] bg-[#FFFFFF] dark:bg-primary rounded-lg p-5">
            <p className="text-xs font-poppins text-[#777777] pb-1">Current Week Started</p>
            <p className="text-base font-semibold font-poppins text-[#00162e] dark:text-darkText">
              {lastResetDate ? formatDate(lastResetDate) : "Since app launch"}
            </p>
          </div>
          <div className="border border-opacity-gradient dark:border-[#1F1F1F] bg-[#FFFFFF] dark:bg-primary rounded-lg p-5">
            <p className="text-xs font-poppins text-[#777777] pb-1">Next Automatic Reset</p>
            <p className="text-base font-semibold font-poppins text-[#593A99]">
              {formatDate(nextReset)}
            </p>
          </div>
          <div className="border border-opacity-gradient dark:border-[#1F1F1F] bg-[#FFFFFF] dark:bg-primary rounded-lg p-5">
            <p className="text-xs font-poppins text-[#777777] pb-1">Automation Status</p>
            <p className="flex items-center gap-2 text-base font-semibold font-poppins text-[#0D9947]">
              <span className="w-2 h-2 bg-[#0D9947] rounded-full"></span> Active
            </p>
          </div>
        </div>

        {/* Pending Preview - this week's accumulation so far */}
        <div className="border border-opacity-gradient dark:border-[#1F1F1F] bg-[#FFFFFF] dark:bg-primary rounded-lg p-6 mb-6">
          <div className="flex items-center justify-between pb-4">
            <h3 className="text-base font-semibold font-poppins text-header">This Week's Coins (Pending Transfer)</h3>
            <span className="px-4 py-1.5 text-sm font-semibold text-[#E89A00] bg-[#E89A00] bg-opacity-15 rounded-lg font-poppins">
              🪙 {grandTotal}
            </span>
          </div>

          {loading ? (
            <p className="py-6 text-sm text-center font-poppins dark:text-darkText">Loading...</p>
          ) : preview.length > 0 ? (
            <div className="overflow-hidden border border-gray-200 dark:border-[#1F1F1F] rounded-lg">
              <div className="flex px-4 py-3 bg-[#00000005] dark:bg-[#1F1F1F] text-sm font-semibold font-poppins text-[#5B5B5B] dark:text-tableDarkLarge">
                <div className="w-[45%]">Host</div>
                <div className="w-[25%] text-center">Gifts Received</div>
                <div className="w-[30%] text-center">Will Receive</div>
              </div>
              {preview.map((h) => (
                <div key={h.host_id} className="flex items-center px-4 py-3 border-t border-gray-100 dark:border-[#1F1F1F]">
                  <div className="w-[45%] font-poppins text-sm dark:text-darkText">{h.host_name || `User #${h.host_id}`}</div>
                  <div className="w-[25%] text-center font-poppins text-sm dark:text-darkText">{h.gift_count}</div>
                  <div className="w-[30%] text-center">
                    <span className="px-3 py-1 text-sm font-semibold text-[#0D9947] bg-[#0D9947] bg-opacity-15 rounded-lg font-poppins">
                      🪙 {h.total_coins}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="py-6 text-sm text-center font-poppins text-[#777777]">No coins collected yet this week</p>
          )}
        </div>

        {/* Past Resets History */}
        <div className="border border-opacity-gradient dark:border-[#1F1F1F] bg-[#FFFFFF] dark:bg-primary rounded-lg p-6">
          <h3 className="text-base font-semibold font-poppins text-header pb-4">Past Reset History</h3>
          {history.length > 0 ? (
            <div className="overflow-hidden border border-gray-200 dark:border-[#1F1F1F] rounded-lg">
              <div className="flex px-4 py-3 bg-[#00000005] dark:bg-[#1F1F1F] text-sm font-semibold font-poppins text-[#5B5B5B] dark:text-tableDarkLarge">
                <div className="w-[30%]">Host</div>
                <div className="w-[25%] text-center">Coins Paid</div>
                <div className="w-[20%] text-center">Gifts</div>
                <div className="w-[25%]">Reset Date</div>
              </div>
              {history.map((h) => (
                <div key={h.id} className="flex items-center px-4 py-3 border-t border-gray-100 dark:border-[#1F1F1F]">
                  <div className="w-[30%] font-poppins text-sm dark:text-darkText">{h.host_name || `User #${h.host_id}`}</div>
                  <div className="w-[25%] text-center font-poppins text-sm font-semibold text-[#0D9947]">🪙 {h.total_coins}</div>
                  <div className="w-[20%] text-center font-poppins text-sm dark:text-darkText">{h.gift_count}</div>
                  <div className="w-[25%] font-poppins text-xs text-[#777777]">
                    {new Date(h.reset_at.replace(' ', 'T')).toLocaleString()}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-16">
              <img src={NoData} alt="no data" className="w-72" />
              <p className="text-sm font-poppins text-[#777777]">No resets have run yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default WeeklyReset;